import { MyLoading } from "@macashipo/mlib"
export default MyLoading
